import type { CatalogPickerItem } from "./useStandardsCatalog";

interface Props {
  readonly open: boolean;
  readonly items: readonly CatalogPickerItem[];
  readonly activeIndex: number;
  readonly anchorStyle: { top: number; left: number } | null;
  readonly onHover: (index: number) => void;
  readonly onSelect: (item: CatalogPickerItem) => void;
}

function truncate(text: string, max: number): string {
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1)}…`;
}

export function MentionPicker({ open, items, activeIndex, anchorStyle, onHover, onSelect }: Props) {
  if (!open || !anchorStyle || items.length === 0) return null;

  const active = items[activeIndex];

  return (
    <div
      className="mention-picker"
      style={{ top: anchorStyle.top, left: anchorStyle.left }}
      role="listbox"
      aria-label="Standards and glossary"
    >
      <ul className="mention-picker-list">
        {items.map((item, i) => (
          <li key={`${item.kind}:${item.id}`}>
            <button
              type="button"
              role="option"
              aria-selected={i === activeIndex}
              className={`mention-picker-option${i === activeIndex ? " is-active" : ""}`}
              onMouseEnter={() => onHover(i)}
              onMouseDown={(e) => {
                e.preventDefault();
                onSelect(item);
              }}
            >
              <span className="mention-picker-option-head">
                <span className={`mention-picker-kind mention-picker-kind--${item.kind}`}>
                  {item.kind === "standard" ? "Standard" : "Glossary"}
                </span>
                <strong>{item.label}</strong>
              </span>
              <span className="mention-picker-option-desc">{truncate(item.description, 120)}</span>
            </button>
          </li>
        ))}
      </ul>
      {active ? (
        <div className="mention-picker-preview" aria-live="polite">
          <strong>{active.label}</strong>
          <p>{active.description}</p>
        </div>
      ) : null}
    </div>
  );
}
